// extracted by mini-css-extract-plugin
export default {"input":"src-components-base-Input-style__iGrLf__input"};